import React, { Component } from 'react';
import Header from './Header';
import alex from '../assets/alex.jpg';
import alexis from '../assets/alexis1.jpg';
import andrew from '../assets/andrew.jpg';
import christian from '../assets/christian.jpg';
import grant from '../assets/grant.jpg';
import johan from '../assets/johan.jpg';
import jordan from '../assets/jordan.jpg';
import karsten from '../assets/karsten.jpg';
import raymond from '../assets/raymond.jpg';
import taylor from '../assets/taylor1.jpg';
import trevor from '../assets/trevor1.jpg';
import zak from '../assets/zak.jpg';
import ComingSoon from './ComingSoon';


const TEAM = [
  {
    name: 'alexis',
    display_name: 'Alexis Sablone',
    image: alexis
  },
  {
    name: 'johan',
    display_name: 'Johan Stuckey',
    image: johan
  },
  {
    name: 'jordan',
    display_name: 'Jordan Taylor',
    image: jordan
  },
  {
    name: 'christian',
    display_name: 'Christian Maalouf',
    image: christian
  },
  {
    name: 'karsten',
    display_name: 'Karsten Kleppan',
    image: karsten
  },
  {
    name: 'raymond',
    display_name: 'Raymond Molinar',
    image: raymond
  },
  {
    name: 'trevor',
    display_name: 'Trevor Thompson',
    image: trevor
  },
  {
    name: 'taylor',
    display_name: 'Taylor Caruso',
    image: taylor
  },
  {
    name: 'alex',
    display_name: 'Alex Schmidt',
    image: alex
  },
  {
    name: 'andrew',
    display_name: 'Andrew Considine',
    image: andrew
  },
  {
    name: 'zak',
    display_name: 'Zac Gracie',
    image: zak
  },  
  {
    name: 'grant',
    display_name: 'Grant Yansura',
    image: grant
  }
]

class Team extends Component {

  buildTeamLinks = () => {
    return TEAM.map((datum, i) => {
      return (
        <div key={datum.name} className="team-photo-wrap">
          <img src={datum.image} className="team-photo" alt={datum.display_name} />
          <span>{ datum.display_name }</span>
        </div>
      )
    });
  }

  render() {
    return (
      <div className="site-wrap">
        <Header page="team" />
        <ComingSoon />
        {/* <div className="team-wrap">
          { this.buildTeamLinks() }
        </div> */}
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/components/Team.js